var map = {
	"./Icon.js": "pb4q",
	"./IconAcademy.js": "wHkX",
	"./IconAddWatchlist.js": "96UP",
	"./IconAddedWatchlist.js": "PLLI",
	"./IconAlert.js": "bfB2",
	"./IconArrowDouble.js": "IQaU",
	"./IconArrowDown.js": "d5CF",
	"./IconArrowDownBig.js": "FJT1",
	"./IconArrowLeft.js": "vL/J",
	"./IconArrowLeftBig.js": "kONi",
	"./IconArrowRight.js": "YAKC",
	"./IconArrowRightBig.js": "jDTs",
	"./IconArrowRightSmall.js": "9rpl",
	"./IconArrowUp.js": "JihD",
	"./IconArrowUpBig.js": "UTMm",
	"./IconAssetSmall.js": "idl1",
	"./IconAssets.js": "2J3k",
	"./IconBadge.js": "922p",
	"./IconBell.js": "RlPV",
	"./IconBellOff.js": "9Ea3",
	"./IconBulletList.js": "4+g9",
	"./IconBuy.js": "clEg",
	"./IconCalendar.js": "q5XV",
	"./IconCalendarSmall.js": "5pJW",
	"./IconChange.js": "AIBE",
	"./IconChart.js": "FxY0",
	"./IconChartBars.js": "wADZ",
	"./IconChartLayout.js": "gGpo",
	"./IconChartLine.js": "h9VQ",
	"./IconCheckmark.js": "HBiW",
	"./IconClock.js": "EAsx",
	"./IconClockSmall.js": "zufT",
	"./IconClose.js": "NRcQ",
	"./IconCloseMedium.js": "R7EV",
	"./IconCloseSmall.js": "+zl3",
	"./IconCloudBig.js": "HMxk",
	"./IconCloudSmall.js": "wPF8",
	"./IconColumns.js": "bc6z",
	"./IconComment.js": "DizW",
	"./IconCommentSmall.js": "mZ9M",
	"./IconCompare.js": "KaEj",
	"./IconConnection.js": "qeIb",
	"./IconConnectionBig.js": "NQHI",
	"./IconConnectionSmall.js": "7zIu",
	"./IconCopy.js": "nGcH",
	"./IconCrown.js": "D5rR",
	"./IconCrownBig.js": "zIW+",
	"./IconCustomize.js": "I4uX",
	"./IconDisk.js": "tRXQ",
	"./IconDiskSmall.js": "FNPr",
	"./IconDots.js": "+fFK",
	"./IconDotsSmall.js": "EF/Y",
	"./IconDotsVertical.js": "11UO",
	"./IconDuplicate.js": "c0rQ",
	"./IconEdit.js": "DVZE",
	"./IconEditSmall.js": "kfrW",
	"./IconEnvelope.js": "y25B",
	"./IconError.js": "70yh",
	"./IconExternalLink.js": "W3Aw",
	"./IconEye.js": "U+13",
	"./IconEyeDisabled.js": "o5yB",
	"./IconEyeDisabledSmall.js": "IphW",
	"./IconEyeSmall.js": "jpOL",
	"./IconFacebook.js": "5YUD",
	"./IconFilter.js": "Sn3V",
	"./IconFilterFilled.js": "cmAX",
	"./IconFilterSmall.js": "Wlec",
	"./IconFinance.js": "h6Vg",
	"./IconFire.js": "V3mL",
	"./IconFireFilled.js": "V9SO",
	"./IconFlash.js": "O4px",
	"./IconFlashFilled.js": "kDUI",
	"./IconFolder.js": "u1b9",
	"./IconFollow.js": "TYD8",
	"./IconFollowers.js": "bUR9",
	"./IconFollowing.js": "n3jp",
	"./IconFrozen.js": "obB6",
	"./IconFullscreen.js": "mQD9",
	"./IconFullscreenArrows.js": "2uy3",
	"./IconHamburger.js": "OIp8",
	"./IconHelpRound.js": "ZOvK",
	"./IconHide.js": "fN3t",
	"./IconHistoryClear.js": "Foyd",
	"./IconInfoRound.js": "is11",
	"./IconInfoRoundSmall.js": "pIf5",
	"./IconInsight.js": "zXhw",
	"./IconInterval.js": "8o2d",
	"./IconLike.js": "+E0g",
	"./IconLikeSmall.js": "sctb",
	"./IconLink.js": "hXMv",
	"./IconLinkedIn.js": "Vuss",
	"./IconLock.js": "zWco",
	"./IconLockSmall.js": "DlhM",
	"./IconLogout.js": "BWdc",
	"./IconMail.js": "JriE",
	"./IconMailSmall.js": "qV3o",
	"./IconMerge.js": "bvom",
	"./IconMetamask.js": "jXb0",
	"./IconMetamaskMonochrome.js": "g014",
	"./IconMetric.js": "dn/B",
	"./IconMint.js": "dJ7E",
	"./IconNft.js": "gskF",
	"./IconPause.js": "YMl/",
	"./IconPauseRound.js": "oDQG",
	"./IconPicture.js": "Nf7p",
	"./IconPlay.js": "5LS4",
	"./IconPlayRound.js": "X5et",
	"./IconPlus.js": "NOUt",
	"./IconPlusRound.js": "kMEJ",
	"./IconPlusRoundSmall.js": "9RVP",
	"./IconPlusSmall.js": "hQzg",
	"./IconPointerRight.js": "91K6",
	"./IconPointerRightSmall.js": "BkmX",
	"./IconProductsTrigger.js": "YvfX",
	"./IconProfile.js": "HvFk",
	"./IconProfileSmall.js": "+FPA",
	"./IconQuestionRound.js": "ndIz",
	"./IconQuestionRoundSmall.js": "5MNI",
	"./IconQuote.js": "5QK7",
	"./IconReddit.js": "9dbB",
	"./IconRefresh.js": "DDAA",
	"./IconRemove.js": "M5i9",
	"./IconRemoveSmall.js": "Q1kQ",
	"./IconReport.js": "5NUW",
	"./IconRevert.js": "rjCz",
	"./IconRing.js": "tqXr",
	"./IconSave.js": "6+GU",
	"./IconScreener.js": "C+yG",
	"./IconSearch.js": "MI+R",
	"./IconSearchSmall.js": "Ffuc",
	"./IconSell.js": "2XBv",
	"./IconSettings.js": "R5Kl",
	"./IconSettingsBig.js": "ELe6",
	"./IconShare.js": "dwS9",
	"./IconSidebar.js": "AeVa",
	"./IconSigma.js": "qq/0",
	"./IconSignal.js": "yxta",
	"./IconSocial.js": "NdW2",
	"./IconSubtractRound.js": "gndq",
	"./IconSuccessRound.js": "2JbK",
	"./IconTelegram.js": "Icqc",
	"./IconTextBig.js": "4lG9",
	"./IconTextBold.js": "5TKE",
	"./IconTextItalic.js": "7etw",
	"./IconTextSmall.js": "ViQ4",
	"./IconTextUnderline.js": "bP13",
	"./IconTriangleBoth.js": "8PTP",
	"./IconTriangleDown.js": "7Fk3",
	"./IconTriangleRight.js": "sCSJ",
	"./IconTriangleUp.js": "7uXM",
	"./IconTwitter.js": "BCFc",
	"./IconUpDown.js": "irt0",
	"./IconUpdate.js": "ubiX",
	"./IconViewOption.js": "iEWb",
	"./IconWallet.js": "SaKN",
	"./IconWarning.js": "nHnd",
	"./IconWatchlist.js": "WXPZ",
	"./IconWatchlistPlus.js": "TZkI",
	"./IconWordsList.js": "/B60",
	"./iconTag.js": "LKxW",
	"./index.js": "uEP8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DZfd";